module.exports = __webpack_public_path__ + "img/OPP1986.bf60fa5f.png";